export const NAMESPACE = 'a namespace'
export const USER = 'at least one user'
export const ADD_PERMISSIONS = 'Add Permissions'
export const REMOVE_PERMISSIONS = 'Remove Permissions'
export const EDIT_PERMISSIONS = 'Edit Permissions'
export const COPY_PERMISSIONS = 'Copy Permissions'
export const PERMISSIONS = 'Permissions'
export const REQUIRED_FIELDS = 'All fields are required.'
export const CLOSE_DRAWER = 'Close Drawer'

export const PLEASE_SELECT = 'Please select'
